import { createContext, useContext } from "react";

/*
  Sinaliza que a árvore atual está sendo renderizada para EXPORTAÇÃO EM PDF
  (bloco `.print-only` capturado pelo backend via puppeteer). Componentes com
  seções colapsáveis / listas truncadas ("Ver mais") consultam este contexto
  para renderizar SEMPRE expandidos no PDF, sem afetar a visão interativa na
  tela (onde o valor padrão é `false`).
*/
const PrintExportContext = createContext(false);

export const PrintExportProvider = ({ value = true, children }) => (
  <PrintExportContext.Provider value={value}>
    {children}
  </PrintExportContext.Provider>
);

export function useIsPrintExport() {
  return useContext(PrintExportContext);
}

export default PrintExportContext;
